import { apolloCache } from '../src/createClient';

export { createClient, resetApolloStats } from '../src/createClient';
export type { BroadcastConfigurableInMemoryCache } from '../src/createClient';

export function getApolloCache() {
	return apolloCache;
}
